<template>
  <v-card class="ui-module-card" color="primary">
    <v-card-title>
      <div class="text-h5 font-weight-bold mb-4">Desarrollo del elemento</div>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="!loading">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="secondary" @click="refrescarDatos" :loading="loading" v-bind="attrs" v-on="on">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Refrescar información</span>
      </v-tooltip>
      <v-tabs v-if="!loading" v-model="selectedTab" color="secondary" fixed-tabs>
        <v-tab class="font-weight-bold">Evaluaciones <br />médicas</v-tab>
        <v-tab class="font-weight-bold"
          >Resultados<br />consulta<br />
          previa</v-tab
        >
        <v-tab class="font-weight-bold" v-if="perfil !== PERFILES['Enlace C3']">Biométricos</v-tab>
        <v-tab v-if="estatus == 1" class="font-weight-bold">Capacitaciones</v-tab>
        <v-tab v-if="estatus == 1" class="font-weight-bold">Armas<br />asignadas</v-tab>
        <v-tab v-if="estatus == 1" class="font-weight-bold">Equipamiento</v-tab>
      </v-tabs>
    </v-card-title>
    <v-card-text>
      <v-container v-if="loading" fluid>
        <v-row align="center" justify="center" style="min-height: 300px">
          <v-col cols="12" align="center">
            <v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
            <div class="text-h6 mt-4">Cargando información del elemento...</div>
          </v-col>
        </v-row>
      </v-container>
      <v-tabs-items v-else v-model="selectedTab" class="transparent">
        <v-tab-item key="1">
          <v-container>
            <v-row v-if="evaluaciones.length > 0">
              <v-col cols="4" v-for="evaluacionMedica in evaluaciones" :key="evaluacionMedica.id">
                <v-card color="primary" class="ui-module-card">
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            :value="evaluacionMedica.fechaAplicacion"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="Fecha de aplicación"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <div class="text-caption">Resultados</div>
                        </v-col>
                        <v-col cols="10">
                          <div class="text-subtitle-2 font-weight-bold">Clínica</div>
                        </v-col>
                        <v-col cols="2">
                          <v-icon v-if="evaluacionMedica.clinica == 1" color="success">mdi-check</v-icon>
                          <v-icon v-else color="error">mdi-close-circle</v-icon>
                        </v-col>
                        <v-col cols="10">
                          <div class="text-subtitle-2 font-weight-bold">Acondicionamiento físico</div>
                        </v-col>
                        <v-col cols="2">
                          <v-icon v-if="evaluacionMedica.acondicionamientoFisico == 1" color="success"
                            >mdi-check</v-icon
                          >
                          <v-icon v-else color="error">mdi-close-circle</v-icon>
                        </v-col>
                        <v-col cols="10">
                          <div class="text-subtitle-2 font-weight-bold">Psicológica</div>
                        </v-col>
                        <v-col cols="2">
                          <v-icon v-if="evaluacionMedica.psicologica == 1" color="success">mdi-check</v-icon>
                          <v-icon v-else color="error">mdi-close-circle</v-icon>
                        </v-col>
                        <v-col cols="12">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col cols="10">
                          <div class="text-subtitle-2 font-weight-bold">Resultado</div>
                        </v-col>
                        <v-col cols="2">
                          <v-icon v-if="evaluacionMedica.resultado == 1" color="success">mdi-check</v-icon>
                          <v-icon v-else color="error">mdi-close-circle</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text--secondary text-h6">Este personal no cuenta con evaluaciones médicas registradas</div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="2">
          <v-container>
            <v-row v-if="dictamenes && dictamenes.length > 0">
              <v-col cols="4" v-for="dictamen in dictamenes" :key="dictamen.id">
                <v-card color="primary" class="ui-module-card">
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            :value="dictamen.fecha"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="Fecha de realizacion"
                          ></v-text-field>
                          <v-text-field
                            :value="dictamen.afis"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="AFIS"
                          ></v-text-field>
                          <v-text-field
                            :value="dictamen.suic"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="SUIC"
                          ></v-text-field>
                          <v-text-field
                            :value="dictamen.rnsp"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="RNSP"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" align="center" v-if="perfil === PERFILES['Personal/Site']">
                          <div class="text-caption font-weight-bold">Resultado en consulta previa</div>
                          <div class="text-subtitle-2">
                            {{ dictamen.resultadoConsultaPrevia }}
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <v-alert type="success" v-if="dictamen.fk_idCatAlerta == 1"
                            >No se encontró incidente alguno</v-alert
                          >
                          <v-alert type="warning" class="black--text" v-if="dictamen.fk_idCatAlerta == 2"
                            >Se encontró incidente menor</v-alert
                          >
                          <v-alert type="error" v-if="dictamen.fk_idCatAlerta == 3"
                            >Se encontró incidente mayor</v-alert
                          >
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text-h6">No se ha hecho la consulta previa de personal</div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="3">
          <v-container>
            <v-row v-if="biometricos.length > 0">
              <v-col cols="4" v-for="biometrico in biometricos" :key="biometrico.idBiometricoPersonal" class="d-flex">
                <v-card color="primary" class="ui-module-card d-flex flex-column" style="width: 100%">
                  <v-card-title class="justify-center d-block" align="center">
                    <v-icon size="60" color="secondary" v-if="biometrico.tipoBiometrico.id == 1"
                      >mdi-fingerprint</v-icon
                    >
                    <v-icon size="60" color="secondary" v-else-if="biometrico.tipoBiometrico.id == 2"
                      >mdi-microphone</v-icon
                    >
                    <v-icon size="60" color="secondary" v-else>mdi-camera</v-icon>
                    <div class="font-weight-bold text-h6 d-block">{{ biometrico.tipoBiometrico.title }}</div>
                  </v-card-title>
                  <v-card-text class="flex-grow-1">
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            :value="biometrico.fechaRealizacion"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="Fecha de captura"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <audio-player-card
                            v-if="biometrico.tipoBiometrico.id == 2"
                            :src="biometrico.url"
                            :filename="biometrico.nombre"
                          />
                          <v-img
                            v-else-if="getDocumentType(biometrico.nombre) == 'img'"
                            :src="biometrico.url"
                            contain
                          ></v-img>
                          <embed
                            v-else-if="getDocumentType(biometrico.nombre) == 'pdf'"
                            width="100%"
                            class="pdf"
                            name="plugin"
                            :src="biometrico.url + '#toolbar=0&navpanes=0&scrollbar=0'"
                            type="application/pdf"
                          />
                        </v-col>
                        <v-col cols="12" align="center">
                          <div class="text-caption font-weight-bold">Observaciones</div>
                          <div
                            v-if="biometrico.observaciones && biometrico.observaciones.length > 0"
                            class="text-subtitle-2"
                          >
                            {{ biometrico.observaciones }}
                          </div>
                          <div v-else class="text-subtitle-2">Ninguna</div>
                        </v-col>
                        <v-col cols="12" align="center" v-if="biometrico.url || puedeEliminarBiometrico">
                          <v-btn v-if="biometrico.url" color="secondary" @click="download(biometrico.url)"
                            >Descargar</v-btn
                          >
                          <v-btn
                            v-if="puedeEliminarBiometrico"
                            icon
                            color="error"
                            @click="abrirConfirmarEliminarBiometrico(biometrico)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text--secondary text-h6">
                  Este personal no cuenta con captura de biométricos registrados
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="4">
          <v-container fluid class="pa-3">
            <!-- NIVEL 1: Años -->
            <v-data-table
              class="exp-table exp-anio"
              :headers="headersAnio"
              :items="aniosVisibles"
              :expanded="expandedAnios"
              @item-expanded="onAnioExpanded"
              item-key="anio"
              show-expand
              dark
              hide-default-footer
              disable-pagination
              dense
            >
              <template v-slot:[`item.anio`]="{ item }">
                <div class="nivel-pill nivel-anio">
                  <v-icon small class="mr-2">mdi-calendar</v-icon>
                  <span class="font-weight-bold">{{ item.anio }}</span>
                </div>
              </template>

              <template v-slot:expanded-item="{ headers: hdrs, item: anioRow }">
                <td :colspan="hdrs.length" class="pa-0 expanded-anio-cell">
                  <!-- NIVEL 2: Perfiles -->
                  <v-data-table
                    class="exp-table exp-perf"
                    :headers="headersPerf"
                    :items="perfilesDeAnio(anioRow)"
                    :expanded="expandedPerfiles"
                    @item-expanded="onPerfilExpanded"
                    item-key="key"
                    show-expand
                    dark
                    hide-default-footer
                    disable-pagination
                    dense
                  >
                    <template v-slot:[`item.perfil`]="{ item }">
                      <div class="nivel-pill nivel-perf">
                        <v-icon small class="mr-2">mdi-shield-account-outline</v-icon>
                        <span class="font-weight-medium">{{ item.perfil }}</span>
                      </div>
                    </template>

                    <template v-slot:no-data>
                      <div v-if="loadingPerfiles" class="text-center py-6">
                        <v-progress-circular indeterminate color="secondary" size="32"></v-progress-circular>
                        <div class="text-body-1 mt-2">Cargando información...</div>
                      </div>
                      <div v-else class="text-body-1 text-center py-6">No hay perfiles registrados</div>
                    </template>

                    <template v-slot:expanded-item="{ headers: hdrsPerf, item: perfRow }">
                      <td :colspan="hdrsPerf.length" class="pa-0 expanded-perf-cell">
                        <!-- NIVEL 3: Tipos -->
                        <v-data-table
                          class="exp-table exp-tipo"
                          :headers="headersTipo"
                          :items="tiposDeAnioPerfil(anioRow, perfRow)"
                          :expanded="expandedTipos"
                          @item-expanded="onTipoExpanded"
                          item-key="key"
                          show-expand
                          dark
                          hide-default-footer
                          disable-pagination
                          dense
                        >
                          <template v-slot:[`item.tipo`]="{ item }">
                            <div class="nivel-pill nivel-tipo">
                              <v-icon small class="mr-2">mdi-tag-outline</v-icon>
                              <span class="font-weight-medium">{{ item.tipo }}</span>
                            </div>
                          </template>

                          <template v-slot:no-data>
                            <div class="text-body-1 text-center py-6">No hay tipos registrados</div>
                          </template>

                          <template v-slot:expanded-item="{ headers: hdrsTipo, item: tipoRow }">
                            <td :colspan="hdrsTipo.length" class="pa-0 expanded-tipo-cell">
                              <!-- NIVEL 4: Categorías -->
                              <v-data-table
                                class="exp-table exp-cat"
                                :headers="headersCat"
                                :items="categoriasDeAnioPerfilTipo(anioRow, perfRow, tipoRow)"
                                :expanded.sync="expandedCats"
                                item-key="key"
                                show-expand
                                dark
                                hide-default-footer
                                disable-pagination
                                dense
                              >
                                <template v-slot:[`item.categoria`]="{ item }">
                                  <div class="nivel-pill nivel-cat">
                                    <v-icon small class="mr-2">mdi-folder-outline</v-icon>
                                    <span class="font-weight-medium">{{ item.categoria }}</span>
                                  </div>
                                </template>

                                <template v-slot:no-data>
                                  <div class="text-body-1 text-center py-6">No hay categorías registradas</div>
                                </template>

                                <template v-slot:expanded-item="{ headers: hdrsCat, item: catRow }">
                                  <td :colspan="hdrsCat.length" class="pa-0 expanded-cat-cell">
                                    <!-- NIVEL 5: cursos con sus datos -->
                                    <v-list v-if="catRow.cursos.length > 0" dense class="cursos-list">
                                      <v-list-item
                                        v-for="curso in catRow.cursos"
                                        :key="curso.idCursoPersonal"
                                        class="curso-item"
                                      >
                                        <v-list-item-content>
                                          <v-list-item-title class="curso-nombre">
                                            <span class="curso-dot">•</span>
                                            {{ curso.subcategoria }}
                                          </v-list-item-title>
                                          <v-list-item-subtitle class="curso-datos mt-1">
                                            <span class="dato-label">Asistió:</span>
                                            <v-icon x-small :color="curso.asistencia == 1 ? 'success' : 'error'" class="mx-1">
                                              {{ curso.asistencia == 1 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                            </v-icon>
                                            <span class="dato-sep">·</span>
                                            <span class="dato-label">Calificación:</span>
                                            <span class="dato-val ml-1">{{ curso.calificacion && curso.calificacion.length > 0 ? curso.calificacion : '—' }}</span>
                                            <span class="dato-sep">·</span>
                                            <span class="dato-label">Cal. Evaluador:</span>
                                            <span class="dato-val ml-1">{{ curso.calificacionEvaluacion || '—' }}</span>
                                            <template v-if="curso.comentario && curso.comentario.length > 0">
                                              <span class="dato-sep">·</span>
                                              <span class="dato-label">Comentario:</span>
                                              <span class="dato-val ml-1">{{ curso.comentario }}</span>
                                            </template>
                                          </v-list-item-subtitle>
                                        </v-list-item-content>
                                      </v-list-item>
                                    </v-list>
                                    <div v-else class="text-body-2 text-center py-4 sin-cursos-msg">
                                      Sin capacitaciones registradas en esta categoría
                                    </div>
                                  </td>
                                </template>
                              </v-data-table>
                            </td>
                          </template>
                        </v-data-table>
                      </td>
                    </template>
                  </v-data-table>
                </td>
              </template>

              <template v-slot:no-data>
                <div class="text-h6 text-center py-8">Este personal no cuenta con capacitaciones registradas</div>
              </template>
            </v-data-table>
          </v-container>
        </v-tab-item>
        <v-tab-item key="6">
          <v-container>
            <v-row v-if="armas.length > 0">
              <v-col cols="4" v-for="armaPersonal in armas" :key="armaPersonal.id">
                <v-card color="primary" class="ui-module-card">
                  <v-card-title class="font-weight-bold justify-center">{{
                    armaPersonal.Arma.CatClase.clase
                  }}</v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="6">
                          <div class="text-subtitle-2 font-weight-bold">Número de inventario</div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <div class="text-subtitle-2">
                            {{ armaPersonal.Arma.noEconomico }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="text-subtitle-2 font-weight-bold">Matrícula</div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <div class="text-subtitle-2">
                            {{ armaPersonal.Arma.matricula }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="text-subtitle-2 font-weight-bold">Modelo</div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <div class="text-subtitle-2">
                            {{ armaPersonal.Arma.CatModelo.modelo }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="text-subtitle-2 font-weight-bold">Calibre</div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <div class="text-subtitle-2">
                            {{ armaPersonal.Arma.CatCalibre.title }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="text-subtitle-2 font-weight-bold">Estatus</div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <div class="text-subtitle-2">
                            {{ armaPersonal.Arma.CatEstatus.title }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="text-subtitle-2 font-weight-bold">Armero</div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <div class="text-subtitle-2">
                            {{ armaPersonal.Arma.armeros }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text--secondary text-h6">Este personal no cuenta con armas asignadas</div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="7">
          <v-container>
            <v-row v-if="equipamiento.length > 0">
              <v-col cols="4" v-for="equipamiento in equipamiento" :key="equipamiento.id">
                <v-card color="primary" class="ui-module-card">
                  <v-card-title class="font-weight-bold justify-center">Asignación de equipamiento</v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            :value="equipamiento.fechaAsignacion"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="Fecha de asignación"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-list color="primary">
                            <v-subheader class="font-weight-black">Equipo asignado:</v-subheader>
                            <v-list-item v-for="equipo in equipamiento.equipoAsignado" :key="equipo.id">
                              <v-list-item-content>
                                <v-list-item-subtitle>{{
                                  equipo.Equipo.CatItem.CatTipoItem.title
                                }}</v-list-item-subtitle>
                                <v-list-item-title class="font-weight-bold">{{
                                  equipo.Equipo.CatItem.item
                                }}</v-list-item-title>
                                <v-list-item-subtitle>{{ equipo.Equipo.numero }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text--secondary text-h6">
                  Este personal no cuenta con asignaciones de equipamiento registradas
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { PERFILES } from '@/perfiles.js'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import AudioPlayerCard from './AudioPlayerCard.vue'

export default {
  components: {
    AudioPlayerCard,
  },

  props: {
    estatus: {
      type: Number,
    },

    idPersonal: {
      type: Number,
      required: true,
    },
  },

  computed: {
    ...mapGetters({ perfil: 'getPerfil' }),
    ...mapGetters('evaluacionMedica', { evaluaciones: 'getEvaluacionMedica' }),
    ...mapGetters('dictamenPersonal', { dictamenes: 'getDictamenPersonal' }),
    ...mapGetters('biometrico', { biometricos: 'getBiometricosPersonal' }),
    ...mapGetters('armaPersonal', { armas: 'getArmasPersonal' }),
    ...mapGetters('asignacionEquipo', { equipamiento: 'getAsignacionesEquipo' }),
    ...mapGetters('capacitaciones', {
      aniosCursos: 'getAniosCursos',
      getPerfilesCursosDeAnio: 'getPerfilesCursosDeAnio',
      todasLasCategorias: 'getCategorias',
      cursosNoProgramadosDePersonal: 'getCursosNoProgramadosDePersonal',
    }),
    ...mapGetters('curso', { cursosCatalogo: 'getCursos' }),

    cursos() {
      return this.cursosNoProgramadosDePersonal.map((vinculado) => {
        const curso = this.cursosCatalogo.find((c) => c.id === vinculado.fk_idCurso)
        return {
          idCursoPersonal: vinculado.id,
          subcategoria: curso?.subcategoria || vinculado.curso,
          categoria: curso?.CatCategoria?.categoria,
          fk_idTipoCurso: curso?.CatCategoria?.fkidTipoCurso,
          fechaRegistro: vinculado.fechaRegistro,
          asistencia: vinculado.asistencia,
          calificacion: vinculado.calificacion,
          calificacionEvaluacion: vinculado.calificacionEvaluacion,
          comentario: vinculado.comentario,
        }
      })
    },

    aniosVisibles() {
      const aniosConCursos = new Set(this.cursos.map((c) => this._anioDeCurso(c)))
      return this.aniosCursos
        .map((a) => ({ anio: a.title, idAnioCurso: a.id }))
        .filter((row) => aniosConCursos.has(row.anio))
    },

    puedeEliminarBiometrico() {
      return [PERFILES.REP_BIOMETRIA, PERFILES['ADMINSITRADOR GENERAL'], PERFILES.REP_ADMINISTRADOR].includes(
        this.perfil
      )
    },
  },

  data() {
    return {
      selectedTab: null,
      loading: false,
      loadingPerfiles: false,
      PERFILES,
      expandedAnios: [],
      expandedPerfiles: [],
      expandedTipos: [],
      expandedCats: [],
      headersAnio: [
        { text: 'Año', value: 'anio', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false, align: 'right' },
      ],
      headersPerf: [
        { text: 'Perfil', value: 'perfil', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false, align: 'right' },
      ],
      headersTipo: [
        { text: 'Tipo', value: 'tipo', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false, align: 'right' },
      ],
      headersCat: [
        { text: 'Categoría', value: 'categoria', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false, align: 'right' },
      ],
    }
  },

  async mounted() {
    if (this.idPersonal) {
      await this.cargarDatos()
    }
  },

  methods: {
    ...mapActions('evaluacionMedica', ['fetchEvaluacionMedicaByPersonal']),
    ...mapActions('dictamenPersonal', ['fetchDictamenPersonal']),
    ...mapActions('biometrico', ['fetchBiometricosPersonal']),
    ...mapActions('armaPersonal', ['fetchArmasPersonal']),
    ...mapActions('asignacionEquipo', ['fetchAsignacionEquipoByPersonal']),
    ...mapActions('capacitaciones', [
      'fetchAniosCursos',
      'fetchPerfilesCursosByAnioCurso',
      'fetchCategorias',
      'fetchCursosNoProgramadosByPersonal',
    ]),
    ...mapActions('curso', ['fetchCursos']),
    ...mapMutations('dialog', ['SET_DIALOG']),

    async cargarDatos() {
      this.loading = true
      try {
        await Promise.all([
          this.fetchEvaluacionMedicaByPersonal(this.idPersonal),
          this.fetchDictamenPersonal(this.idPersonal),
          this.fetchBiometricosPersonal(this.idPersonal),
          this.fetchCursosNoProgramadosByPersonal(this.idPersonal),
          this.fetchCursos(),
          this.fetchArmasPersonal(this.idPersonal),
          this.fetchAsignacionEquipoByPersonal(this.idPersonal),
          this.fetchAniosCursos(),
          this.fetchCategorias(),
        ])
      } catch (error) {
        console.error('Error cargando datos del desarrollo del elemento:', error)
      } finally {
        this.loading = false
      }
    },

    async refrescarDatos() {
      await this.cargarDatos()
    },

    download(url) {
      window.open(url, '_blank')
    },

    abrirConfirmarEliminarBiometrico(biometrico) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.CONFIRMAR_ELIMINAR_BIOMETRICO,
        props: { biometrico },
        listeners: { updated: this.fetchBiometricosPersonalRefresh },
      })
    },

    async fetchBiometricosPersonalRefresh() {
      await this.fetchBiometricosPersonal(this.idPersonal)
    },

    getDocumentType(filename) {
      const extension = filename.split('.').pop().toLowerCase()
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
        return 'img'
      } else if (extension === 'pdf') {
        return 'pdf'
      }
      return 'unknown'
    },

    _anioDeCurso(c) {
      const fecha = c.fechaRegistro || ''
      const match = fecha.match(/\d{4}/)
      return match ? match[0] : null
    },

    _categoriaDeCurso(c) {
      return c.categoria
    },

    _cursosDeAnio(anioRow) {
      return this.cursos.filter((c) => this._anioDeCurso(c) === anioRow.anio)
    },

    _categoriasDelPerfil(idPerfilCurso) {
      return this.todasLasCategorias.filter(
        (cat) => cat.catPerfilCurso?.id === idPerfilCurso || cat.fk_idCatPerfilCurso === idPerfilCurso
      )
    },

    perfilesDeAnio(anioRow) {
      const cursosDelAnio = this._cursosDeAnio(anioRow)
      return this.getPerfilesCursosDeAnio
        .map((p) => ({
          key: `${anioRow.anio}-${p.id}`,
          perfil: p.descripcion,
          idPerfilCurso: p.id,
        }))
        .filter((perfilRow) => {
          const nombresCategoria = this._categoriasDelPerfil(perfilRow.idPerfilCurso).map((cat) => cat.categoria)
          return cursosDelAnio.some((c) => nombresCategoria.includes(this._categoriaDeCurso(c)))
        })
    },

    tiposDeAnioPerfil(anioRow, perfilRow) {
      const idsVistos = new Set()
      const tipos = []
      this.todasLasCategorias.forEach((cat) => {
        const idTipoCurso = cat.fk_idTipoCurso
        if (idsVistos.has(idTipoCurso)) return
        idsVistos.add(idTipoCurso)
        tipos.push({ key: `${perfilRow.key}-${idTipoCurso}`, tipo: cat.catTipoCurso?.title, idTipoCurso })
      })
      return tipos
    },

    categoriasDeAnioPerfilTipo(anioRow, perfilRow, tipoRow) {
      const cursosDelAnio = this._cursosDeAnio(anioRow)
      const categoriasDelTipo = this._categoriasDelPerfil(perfilRow.idPerfilCurso).filter(
        (cat) => cat.fk_idTipoCurso === tipoRow.idTipoCurso
      )
      return categoriasDelTipo.map((cat) => ({
        key: `${tipoRow.key}-${cat.id}`,
        categoria: cat.categoria,
        idCategoria: cat.id,
        cursos: cursosDelAnio.filter((c) => this._categoriaDeCurso(c) === cat.categoria),
      }))
    },

    async onAnioExpanded({ item, value }) {
      this.expandedAnios = value
        ? [...this.expandedAnios, item]
        : this.expandedAnios.filter((a) => a.anio !== item.anio)

      if (value && item.idAnioCurso) {
        this.loadingPerfiles = true
        try {
          await this.fetchPerfilesCursosByAnioCurso(item.idAnioCurso)
        } finally {
          this.loadingPerfiles = false
        }
      }
    },

    onPerfilExpanded({ item, value }) {
      this.expandedPerfiles = value ? [item] : []
      this.expandedTipos = []
      this.expandedCats = []
    },

    onTipoExpanded({ item, value }) {
      this.expandedTipos = value ? [item] : []
      this.expandedCats = []
    },
  },
}
</script>

<style scoped>
/* ── Inputs (v-text-field readonly de cada tab) ── */
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep input {
  color: #e0e0e0 !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

/* ── Cards internas de cada tab ── */
::v-deep .ui-module-card {
  background: rgba(26, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-card:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  box-shadow: 0 8px 32px rgba(var(--v-secondary-base-rgb), 0.2) !important;
  transform: translateY(-2px);
}

/* ── Tabs ── */
::v-deep .v-tab {
  color: rgba(224, 224, 224, 0.7) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .v-tab:hover {
  color: var(--v-secondary-base) !important;
  background: rgba(var(--v-secondary-base-rgb), 0.08);
}

::v-deep .v-tab--active {
  color: var(--v-secondary-base) !important;
  font-weight: 700 !important;
}

::v-deep .v-tabs-slider {
  background: var(--v-secondary-base) !important;
  height: 3px !important;
  border-radius: 3px 3px 0 0;
  box-shadow: 0 2px 8px rgba(var(--v-secondary-base-rgb), 0.5);
}

::v-deep .v-tabs-items {
  background: transparent !important;
}

/* ── Botones ── */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}

/* ── Tooltips ── */
::v-deep .v-tooltip__content {
  background: rgba(16, 16, 30, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* ── Dividers ── */
::v-deep .v-divider {
  border-color: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

/* ── Títulos y textos ── */
.text-h5,
.text-h6 {
  color: #ffffff !important;
}

::v-deep .text-subtitle-2 {
  color: #e0e0e0 !important;
}

::v-deep .text--secondary {
  color: rgba(224, 224, 224, 0.6) !important;
}

/* ── Listas (equipamiento) ── */
::v-deep .v-list {
  background: transparent !important;
}

::v-deep .v-subheader {
  color: var(--v-secondary-base) !important;
}

/* ─── Capacitaciones: pills por nivel ─── */
.nivel-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 0.875rem;
}
.nivel-anio {
  background: rgba(var(--v-secondary-base-rgb), 0.15);
  color: var(--v-secondary-base) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.35);
}
.nivel-tipo {
  background: rgba(251, 191, 36, 0.15);
  color: #fbbf24 !important;
  border: 1px solid rgba(251, 191, 36, 0.35);
}
.nivel-cat {
  background: rgba(96, 165, 250, 0.15);
  color: #60a5fa !important;
  border: 1px solid rgba(96, 165, 250, 0.35);
}

/* ─── NIVEL 1: tabla años ─── */
::v-deep .exp-anio.v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  border-radius: 12px;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2);
  overflow: hidden;
}
::v-deep .exp-anio > .v-data-table__wrapper,
::v-deep .exp-anio > .v-data-table__wrapper > table,
::v-deep .exp-anio > .v-data-table__wrapper > table > tbody {
  background: transparent !important;
}
::v-deep .exp-anio > .v-data-table__wrapper > table > thead {
  background: rgba(var(--v-secondary-base-rgb), 0.12) !important;
}
::v-deep .exp-anio .v-data-table-header th {
  color: var(--v-secondary-base) !important;
  font-weight: 700 !important;
  font-size: 0.85rem !important;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  border-bottom: 2px solid rgba(var(--v-secondary-base-rgb), 0.3) !important;
  padding: 18px 20px !important;
  background: transparent !important;
}
::v-deep .exp-anio tbody tr:not(.v-data-table__expanded) {
  background: transparent !important;
  transition: background 0.2s;
}
::v-deep .exp-anio tbody tr:not(.v-data-table__expanded):hover {
  background: rgba(var(--v-secondary-base-rgb), 0.06) !important;
}
::v-deep .exp-anio tbody td {
  background: transparent !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.1) !important;
  padding: 16px 20px !important;
}
::v-deep .exp-anio .v-data-table__expand-icon {
  color: var(--v-secondary-base) !important;
}
::v-deep .exp-anio .v-data-table__expanded.v-data-table__expanded__content > td {
  background: transparent !important;
  padding: 0 !important;
  border-bottom: 2px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
}

/* ─── NIVEL 2: tabla perfiles ─── */
.expanded-anio-cell {
  border-left: 4px solid rgba(var(--v-secondary-base-rgb), 0.4);
}
.nivel-perf {
  background: rgba(167, 139, 250, 0.15);
  color: #a78bfa !important;
  border: 1px solid rgba(167, 139, 250, 0.35);
}
::v-deep .exp-perf.v-data-table {
  background: rgba(167, 139, 250, 0.03) !important;
  border-radius: 0 !important;
}
::v-deep .exp-perf > .v-data-table__wrapper,
::v-deep .exp-perf > .v-data-table__wrapper > table,
::v-deep .exp-perf > .v-data-table__wrapper > table > tbody {
  background: transparent !important;
}
::v-deep .exp-perf > .v-data-table__wrapper > table > thead {
  background: rgba(167, 139, 250, 0.08) !important;
}
::v-deep .exp-perf .v-data-table-header th {
  color: #a78bfa !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(167, 139, 250, 0.25) !important;
  padding: 16px 20px 16px 28px !important;
  background: transparent !important;
}
::v-deep .exp-perf tbody tr:not(.v-data-table__expanded) {
  background: transparent !important;
  transition: background 0.2s;
}
::v-deep .exp-perf tbody tr:not(.v-data-table__expanded):hover {
  background: rgba(167, 139, 250, 0.06) !important;
}
::v-deep .exp-perf tbody td {
  background: transparent !important;
  border-bottom: 1px solid rgba(167, 139, 250, 0.08) !important;
  padding: 16px 20px 16px 28px !important;
}
::v-deep .exp-perf .v-data-table__expand-icon {
  color: #a78bfa !important;
}
::v-deep .exp-perf .v-data-table__expanded.v-data-table__expanded__content > td {
  background: transparent !important;
  padding: 0 !important;
  border-bottom: 1px solid rgba(167, 139, 250, 0.15) !important;
}

/* ─── NIVEL 3: tabla tipos ─── */
.expanded-perf-cell {
  border-left: 4px solid rgba(167, 139, 250, 0.4);
}
::v-deep .exp-tipo.v-data-table {
  background: rgba(251, 191, 36, 0.03) !important;
  border-radius: 0 !important;
}
::v-deep .exp-tipo > .v-data-table__wrapper,
::v-deep .exp-tipo > .v-data-table__wrapper > table,
::v-deep .exp-tipo > .v-data-table__wrapper > table > tbody {
  background: transparent !important;
}
::v-deep .exp-tipo > .v-data-table__wrapper > table > thead {
  background: rgba(251, 191, 36, 0.08) !important;
}
::v-deep .exp-tipo .v-data-table-header th {
  color: #fbbf24 !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(251, 191, 36, 0.25) !important;
  padding: 16px 20px 16px 28px !important;
  background: transparent !important;
}
::v-deep .exp-tipo tbody tr:not(.v-data-table__expanded) {
  background: transparent !important;
  transition: background 0.2s;
}
::v-deep .exp-tipo tbody tr:not(.v-data-table__expanded):hover {
  background: rgba(251, 191, 36, 0.06) !important;
}
::v-deep .exp-tipo tbody td {
  background: transparent !important;
  border-bottom: 1px solid rgba(251, 191, 36, 0.08) !important;
  padding: 16px 20px 16px 28px !important;
}
::v-deep .exp-tipo .v-data-table__expand-icon {
  color: #fbbf24 !important;
}
::v-deep .exp-tipo .v-data-table__expanded.v-data-table__expanded__content > td {
  background: transparent !important;
  padding: 0 !important;
  border-bottom: 1px solid rgba(251, 191, 36, 0.15) !important;
}

/* ─── NIVEL 4: tabla categorías ─── */
.expanded-tipo-cell {
  border-left: 4px solid rgba(251, 191, 36, 0.4);
}
::v-deep .exp-cat.v-data-table {
  background: rgba(96, 165, 250, 0.03) !important;
  border-radius: 0 !important;
}
::v-deep .exp-cat > .v-data-table__wrapper,
::v-deep .exp-cat > .v-data-table__wrapper > table,
::v-deep .exp-cat > .v-data-table__wrapper > table > tbody {
  background: transparent !important;
}
::v-deep .exp-cat > .v-data-table__wrapper > table > thead {
  background: rgba(96, 165, 250, 0.08) !important;
}
::v-deep .exp-cat .v-data-table-header th {
  color: #60a5fa !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(96, 165, 250, 0.25) !important;
  padding: 16px 20px 16px 36px !important;
  background: transparent !important;
}
::v-deep .exp-cat tbody tr:not(.v-data-table__expanded) {
  background: transparent !important;
  transition: background 0.2s;
}
::v-deep .exp-cat tbody tr:not(.v-data-table__expanded):hover {
  background: rgba(96, 165, 250, 0.06) !important;
}
::v-deep .exp-cat tbody td {
  background: transparent !important;
  border-bottom: 1px solid rgba(96, 165, 250, 0.08) !important;
  padding: 16px 20px 16px 36px !important;
}
::v-deep .exp-cat .v-data-table__expand-icon {
  color: #60a5fa !important;
}
::v-deep .exp-cat .v-data-table__expanded.v-data-table__expanded__content > td {
  background: transparent !important;
  padding: 0 !important;
  border-bottom: 1px solid rgba(96, 165, 250, 0.15) !important;
}

/* ─── NIVEL 5: lista de cursos ─── */
.expanded-cat-cell {
  border-left: 4px solid rgba(96, 165, 250, 0.4);
}
.cursos-list {
  background: transparent !important;
  padding: 6px 0 !important;
}
.sin-cursos-msg {
  color: rgba(224, 224, 224, 0.5) !important;
}
.curso-item {
  padding: 10px 20px 10px 52px !important;
  min-height: unset !important;
  border-bottom: 1px solid rgba(224, 224, 224, 0.06) !important;
  border-left: 3px solid transparent !important;
  transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease !important;
}
.curso-item:last-child {
  border-bottom: none !important;
}
.curso-item:hover {
  transform: translateX(6px) !important;
  background: rgba(96, 165, 250, 0.07) !important;
  border-left-color: #60a5fa !important;
}
.curso-nombre {
  color: #e0e0e0 !important;
  font-size: 0.875rem !important;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: normal !important;
}
.curso-dot {
  color: #60a5fa;
  font-size: 1.2rem;
  flex-shrink: 0;
}
.curso-datos {
  color: rgba(224, 224, 224, 0.65) !important;
  font-size: 0.78rem !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  white-space: normal !important;
}
.dato-label {
  color: rgba(224, 224, 224, 0.5);
}
.dato-val {
  color: #e0e0e0;
  font-weight: 500;
}
.dato-sep {
  color: rgba(224, 224, 224, 0.3);
  margin: 0 2px;
}
</style>
